// extracted by mini-css-extract-plugin
export default {"draggableElement":"DraggableElement_draggableElement__3Q8xt"};